<div *ngIf="product$ | async as product"
      class="container mb-pdp-tab-content mb-references-tab"
      data-cy="mb-references-tab">

  <div *ngIf="references$ | async as references"
        class="mb-pdp-tab-wrapper mb-references-wrapper">

    <div class="row no-gutters">
      <div class="col-12 p-0 mb-references-tab-headline"
            data-cy="mb-references-tab-headline">
        <span data-cy="mb-references-tab-product-name">
          {{'mbProductTabs.referencesFor' | mbTranslate}} <strong [innerHTML]="product.nameHtml | safeHtml"></strong>
        </span>
      </div>
    </div>

    <div class="container mb-references-tab-container">
      <div class="row">
        <div class="mb-references-publications-label col-12">
          <span data-cy="mb-references-publications-label">
            {{'mbProductTabs.publications' | mbTranslate}}
          </span>
        </div>
        <div mbOpenLinkInNewTab class="col-12">
          <ol class="mb-references-tab-list p-0">
            <ng-container *ngFor="let reference of references">
              <li [innerHTML]="reference.reference" class="mb-referebces-description-list-item"></li>
            </ng-container>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
